import React from 'react';
import { FunnelTemplateGallery } from './components/FunnelTemplateGallery';
export function App() {
  return <FunnelTemplateGallery data-id="element-0" />;
}